import { makeStyles } from '@mui/styles';
import { COLOR_GRAY_70, COLOR_GRAY_90 } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  link: {
    fontFamily: 'Lato',
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: 400,
    color: COLOR_GRAY_70,
  },
  icon: {
    margin: theme.spacing(0, 1),
    marginTop: theme.spacing(0.5),
    color: COLOR_GRAY_70,
    width: 16,
    height: 16,
  },
  titleBreadcrumb: {
    fontFamily: 'Lato',
    fontSize: 28,
    fontStyle: 'normal',
    fontWeight: 700,
    color: COLOR_GRAY_90,
    marginTop: theme.spacing(4),
  },
}));
